export class ServiceError extends Error {
  constructor(public readonly service: string) {
    super(`Unexpected Error on ${service} service.`);
  }
}
